import React, { Fragment } from 'react';
import { SelectDropdown } from '@jetshop/ui/Select';
import t from '@jetshop/intl';
//import { SectionHeading } from './ProductInfo';
import { Label } from '../Forms/Input';

const itemCount = 10;
const items = Array.from({ length: itemCount }).map((_, i) => ({
  value: i + 1
}));

const Quantity = props => {
  return (
    <Fragment>
      <Label>{t(props.name)}</Label>
      <SelectDropdown
        items={items}
        title={props.defaultValue}
        onChange={props.onChange}
      />
    </Fragment>
  );
};

export default Quantity;
